import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

export type RegisterSecondStepFormValues = {
  name: string;
  paymentTypes: boolean[];
  address: string;
  lat: number | null;
  lng: number | null;
};

export type RegisterSecondStepFormValidValues = {
  name: string;
  address: string;
  lat: number | null;
  lng: number | null;
  paymentTypes: { id: string; active: boolean }[];
};

export type IdAndName = {
  id: number;
  name: string;
  address: string;
  lat: number | null;
  lng: number | null;
};

const schema = yup.object({
  name: yup.string().required('company.name.required'),
  paymentTypes: yup
    .array(yup.boolean().required().default(false))
    .required('company.paymentType.required'),
  address: yup.string().required('company.address.required'),
  lat: yup.number().nullable().required('company.lat.required'),
  lng: yup.number().nullable().required('company.lng.required'),
});

export const defaultValues: RegisterSecondStepFormValues = {
  name: '',
  paymentTypes: [],
  address: 'jsbajbfjasf',
  lat: 5444243,
  lng: 42242442,
};

export const validationSchema = yupResolver(schema);
